<template>
  <v-dialog width="500px" v-model="viewMenu">
    <v-card class="px-7 pb-2">
        <v-card-title class="mx-n7 popup-header">{{title}}</v-card-title>
        <v-layout row wrap v-if="knotenlast">
            <v-flex xs3>
                <v-subheader v-text="'Lasfall:'"></v-subheader>                  
            </v-flex>
            <v-flex xs9>
                <v-select label="Lastfall" v-bind:items="lastfallliste" item-text="name" :menu-props="{ offsetY: true }" return-object v-model="knotenlast.Lastfall" required></v-select>
            </v-flex>
            <v-flex xs3>
                <v-subheader v-text="'Knotenliste:'"></v-subheader>                  
            </v-flex>
            <v-flex xs9>
                <v-select label="Knotenliste" :items="knotenliste" item-text="name" :menu-props="{ offsetY: true }" return-object v-model="knotenlast.Knotenliste" multiple small-chips required></v-select>
            </v-flex>
            <v-flex xs3>
                <v-subheader>Fx</v-subheader>
            </v-flex>
            <v-flex xs9>
                <v-text-field label="Fx" type="number" v-model.number="knotenlast.fX" :suffix="KraftEinheit.name" required></v-text-field>
            </v-flex>
            <v-flex xs3>
                <v-subheader>Fy</v-subheader>
            </v-flex>
            <v-flex xs9>
                <v-text-field label="Fy" type="number" v-model.number="knotenlast.fY" :suffix="KraftEinheit.name" required></v-text-field>
            </v-flex>
            <v-flex xs3>
                <v-subheader>M</v-subheader>
            </v-flex>
            <v-flex xs9>
                <v-text-field label="M" type="number" v-model.number="knotenlast.M" :suffix="KraftEinheit.name+LängenEinheit.name" required></v-text-field>
            </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions>
                <v-btn small @click="apply()" color="grey lighten-2" >Übernehmen</v-btn>
                <v-btn small @click="cancel()" color="grey lighten-2" >Abbrechen</v-btn>
                <v-btn small v-if="!$store.getters.newKnotenlast" @click="deleteKnotenlast()" color="grey lighten-2"><v-icon dark color="red">delete_forever</v-icon>Löschen</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */
import KnotenlastClass from '../../js/Knotenlast.js'

export default {
    data(){
        return{
            knotenlast: undefined,
            LängenEinheit: this.$store.state.LängenEinheiten.m,
            KraftEinheit: this.$store.state.KraftEinheiten.kN
        }
    },
    computed: {
        lastfallliste() { return this.$store.state.StatikSystem.Lastfallliste },
        knotenliste() { return this.$store.state.StatikSystem.Knotenliste },
        title() { return this.$store.getters.newKnotenlast || !this.cKnotenlast ? 'Neue Knotenlast' : this.cKnotenlast.name +' bearbeiten'},
        viewMenu: {
            get() { return this.$store.getters.vKnotenlastMenu },   
            set(value) { this.$store.commit('setvKnotenlastMenu', value)} 
        },
        cKnotenlast: {
            get() { return this.$store.getters.cKnotenlast },
            }
        },
    methods: {
        apply(){
            if(this.knotenlast.fX == 0 && this.knotenlast.fY == 0 && this.knotenlast.M == 0 || !this.knotenlast.Knotenliste.length) return console.log('Es sind keine Werte eingetragen.')
            this.knotenlast.fX *= this.KraftEinheit.value
            this.knotenlast.fY *= this.KraftEinheit.value
            this.knotenlast.M *= (this.KraftEinheit.value * this.LängenEinheit.value) 
            this.$store.commit('KnotenlastDialogApply', this.knotenlast)
            this.knotenlast = undefined
        },
        cancel(){
            this.viewMenu = false
            this.knotenlast = undefined
        },
        deleteKnotenlast(){
            this.$store.commit('KnotenlastDialogDelete')
        }
    },
    beforeUpdate(){
        if (!this.knotenlast && this.viewMenu) {
          this.knotenlast = new KnotenlastClass(this.cKnotenlast.list, this.cKnotenlast.fX / this.KraftEinheit.value, this.cKnotenlast.fY / this.KraftEinheit.value, this.cKnotenlast.M / (this.KraftEinheit.value * this.LängenEinheit.value), this.cKnotenlast.Knotenliste, this.cKnotenlast.Lastfall)
        } 
    },
}
</script>
